module.exports = __webpack_public_path__ + "img/WRZS.255e6a36.svg";